import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'
import { getToken } from '@/utils/storage'

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { noAuth: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { noAuth: true }
  },
  {
    path: '/',
    component: () => import('@/components/TabBarLayout.vue'),
    children: [
      { path: 'home', name: 'Home', component: () => import('@/views/tabbar/Home.vue'), meta: { noAuth: true } },
      { path: 'knowledge', name: 'Knowledge', component: () => import('@/views/tabbar/Knowledge.vue') },
      { path: 'practice', name: 'Practice', component: () => import('@/views/tabbar/Practice.vue') },
      { path: 'profile', name: 'Profile', component: () => import('@/views/tabbar/Profile.vue') },
      // Knowledge
      { path: 'knowledge-detail/:id', name: 'KnowledgeDetail', component: () => import('@/views/KnowledgeDetail.vue') },
      { path: 'knowledge-chapter/:id', name: 'KnowledgeChapter', component: () => import('@/views/KnowledgeChapter.vue') },
      { path: 'knowledge-graph', name: 'KnowledgeGraph', component: () => import('@/views/KnowledgeGraph.vue') },
      // Practice
      { path: 'practice-daily', name: 'PracticeDaily', component: () => import('@/views/PracticeDaily.vue') },
      { path: 'practice-reinforce', name: 'PracticeReinforce', component: () => import('@/views/PracticeReinforce.vue') },
      { path: 'onboarding-assessment', name: 'OnboardingAssessment', component: () => import('@/views/OnboardingAssessment.vue') },
      { path: 'practice-exam-list', name: 'PracticeExamList', component: () => import('@/views/PracticeExamList.vue') },
      { path: 'practice-wrong', name: 'PracticeWrong', component: () => import('@/views/PracticeWrong.vue') },
      // AI
      { path: 'ai-chat', name: 'AiChat', component: () => import('@/views/AiChat.vue') },
      { path: 'ai-explain', name: 'AiExplain', component: () => import('@/views/AiExplain.vue') },
      { path: 'ai-generate', name: 'AiGenerate', component: () => import('@/views/AiGenerate.vue') },
      { path: 'ai-strengthen', name: 'AiStrengthen', component: () => import('@/views/AiStrengthen.vue') },
      { path: 'ai-lecture', name: 'AiLecture', component: () => import('@/views/AiLecture.vue') },
      { path: 'ai-report', name: 'AiReport', component: () => import('@/views/AiReport.vue') },
      { path: 'ai-diagnosis', name: 'AiDiagnosis', component: () => import('@/views/AiDiagnosis.vue') },
      // Points
      { path: 'points-shop', name: 'PointsShop', component: () => import('@/views/PointsShop.vue') },
      { path: 'points-detail/:id', name: 'PointsDetail', component: () => import('@/views/PointsDetail.vue') },
      { path: 'points-order/:id?', name: 'PointsOrder', component: () => import('@/views/PointsOrder.vue') },
      { path: 'points-address', name: 'PointsAddress', component: () => import('@/views/PointsAddress.vue') },
      { path: 'points-records', name: 'PointsRecords', component: () => import('@/views/PointsRecords.vue') },
      // Learning
      { path: 'learning-records', name: 'LearningRecords', component: () => import('@/views/LearningRecords.vue') },
      { path: 'student-archive', name: 'StudentArchive', component: () => import('@/views/StudentArchive.vue') },
      { path: 'learning-path', name: 'LearningPath', component: () => import('@/views/LearningPath.vue') },
      { path: 'task-center', name: 'TaskCenter', component: () => import('@/views/TaskCenter.vue') },
      { path: 'classroom', name: 'Classroom', component: () => import('@/views/Classroom.vue') },
      { path: 'teacher-workspace', name: 'TeacherWorkspace', component: () => import('@/views/TeacherWorkspace.vue') },
      { path: 'teacher-ai', name: 'TeacherAi', component: () => import('@/views/TeacherAi.vue') },
      { path: 'teacher-dashboard', name: 'TeacherDashboard', component: () => import('@/views/TeacherDashboard.vue') },
      { path: 'edu-exam/:id', name: 'EduExam', component: () => import('@/views/TeacherExam.vue') },
      { path: 'edu-question/:itemId', name: 'EduQuestion', component: () => import('@/views/TeacherQuestion.vue') },
      { path: 'teacher-exam/:id', name: 'TeacherExam', component: () => import('@/views/TeacherExam.vue') },
      { path: 'teacher-question/:itemId', name: 'TeacherQuestion', component: () => import('@/views/TeacherQuestion.vue') },
      // Others
      { path: 'certificate', name: 'Certificate', component: () => import('@/views/Certificate.vue') },
      { path: 'challenge', name: 'Challenge', component: () => import('@/views/Challenge.vue') },
      { path: 'challenge-detail/:id', name: 'ChallengeDetail', component: () => import('@/views/ChallengeDetail.vue') },
      { path: 'medals', name: 'Medals', component: () => import('@/views/Medals.vue') },
      { path: 'leaderboard', name: 'Leaderboard', component: () => import('@/views/Leaderboard.vue') },
      { path: 'notice', name: 'Notice', component: () => import('@/views/Notice.vue') },
      { path: 'favorites', name: 'Favorites', component: () => import('@/views/Favorites.vue') },
      { path: 'profile-edit', name: 'ProfileEdit', component: () => import('@/views/ProfileEdit.vue') },
      { path: 'settings', name: 'Settings', component: () => import('@/views/Settings.vue') },
      { path: 'feedback', name: 'Feedback', component: () => import('@/views/Feedback.vue') },
      { path: 'about', name: 'About', component: () => import('@/views/About.vue') }
    ]
  },
  {
    path: '/practice-exam/:id?',
    name: 'PracticeExam',
    component: () => import('@/views/PracticeExam.vue')
  },
  {
    path: '/practice-result/:recordId',
    name: 'PracticeResult',
    component: () => import('@/views/PracticeResult.vue')
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL || '/'),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

let loginRequiredNotified = false

router.beforeEach((to, from, next) => {
  if (!to.meta.noAuth && !getToken()) {
    if (!loginRequiredNotified) {
      loginRequiredNotified = true
      ElMessage.warning('请先登录后再使用该功能')
      window.setTimeout(() => {
        loginRequiredNotified = false
      }, 1200)
    }
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router
